import { ENV, ENV_ENUM, LOADING_TYPES } from '@/shared/config';
import { useLoadingStore } from '@/shared/lib/loadingStore';
import type { TimeTrackingWithConditionProps } from './timeTrackingWithCondition';

/**
 * Decides whether report time tracking should be running right now. Enables it only on the staging and customer environments when a profile and AI processing are present, and disables it while the no-API-call modal or an expired token blocks work, while an AIRP report renders in the foreground, or while the finding generation loading text is set.
 *
 * @param props - Report context carrying profileId, reportData, aiProcessing, isOpenNoApiCallingModal and isExpiredToken.
 * @returns An object carrying the isTrackingEnabled flag.
 */
const useTimeTrackingWithCondition = ({
  profileId,
  reportData,
  aiProcessing,
  isOpenNoApiCallingModal,
  isExpiredToken,
}: TimeTrackingWithConditionProps) => {
  const loadingRedux = useLoadingStore((s) => s.loading);

  const { isRenderingBackground, status: reportStatus } = reportData?.report || {};
  const isRendering = reportStatus === 'Rendering';
  const isGeneratingAirpReport = isRendering && isRenderingBackground === false;

  const isTrackingEnabled =
    [ENV_ENUM.staging, ENV_ENUM.customer].includes(ENV) &&
    profileId &&
    aiProcessing &&
    !isOpenNoApiCallingModal &&
    !isExpiredToken &&
    !isGeneratingAirpReport &&
    !loadingRedux.loadingText.includes(LOADING_TYPES.GENERATE_FINDING);

  return { isTrackingEnabled };
};

export default useTimeTrackingWithCondition;
